<div class="layout-wrapper h-screen">
    <header></header>

    <div class="layout-main-container">
        <router-outlet></router-outlet>
    </div>
</div>